"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
/**
 * 自定义页面 - 组件默认属性模板
 * 字段命名务必与对应 right 属性面板中的 v-model 保持一致。
 *
 * 顶层公共字段（每个组件都有，不重复注释）：
 *   component       组件名（与 left 目录下的文件名对应，用于动态渲染）
 *   text            组件在中文名（用于左侧组件库面板展示）
 *   type            组件编号，格式 '大类-小类'（如 '1-1'）
 *   active          当前是否选中（true 时右侧显示对应属性面板）
 *   style           对应的 right 属性面板目录名（如 'contentsstyle'）
 *   componentNumber 组件实例唯一编号（拖入画布后生成，用于排序/查找）
 *   setStyle        组件自身的业务属性集合（下方按组件单独注释）
 */

var componentProperties = new Map();

/* ----------------------------- 1-1 标题文本 ----------------------------- */
componentProperties.set('titleContent', {
  component: 'titleContent',
  text: '标题文字',
  type: '1-1',
  active: false,
  style: 'contentsstyle',
  componentNumber: '',
  setStyle: {
    name: '新品上市',
    // 主标题文字
    description: '8月新品限时秒杀',
    // 描述/副标题文字
    positions: 'left',
    // 对齐方式：left 左对齐 / center 居中
    titleSize: 18,
    // 主标题字号（px）
    descriptionSize: 14,
    // 描述字号（px）
    titleWeight: 500,
    // 主标题粗细（数字）
    descriptionWeight: 400,
    // 描述粗细（数字）
    titleColor: 'rgba(50,50,51,1)',
    // 主标题颜色
    descriptionColor: 'rgba(125,126,128,1)',
    // 描述颜色
    backgroundColor: 'rgba(255,255,255,1)',
    // 整体背景色
    wordHeight: 36,
    // 主标题行高/框体高度（px）
    wordMargin: 12,
    // 左右内边距（px）
    borderBott: false,
    // 是否显示底部分割线
    more: {
      // "查看更多" 配置
      show: false,
      // 是否显示
      type: 0,
      // 样式：0 文字+箭头 / 1 仅文字 / 2 仅箭头
      text: '查看更多',
      // 显示文字
      httpType: 10,
      // 跳转类型：10 内部链接 / 11 外部链接
      http: '' // 跳转地址
    }
  }
});

/* ------------------------------- 1-2 图片 ------------------------------- */
componentProperties.set('imgBottom', {
  component: 'imgBottom',
  text: '图片',
  type: '1-2',
  active: false,
  style: 'imgStyle',
  componentNumber: '',
  setStyle: {
    mode: 1,
    // 展示模式：1 单图 / 2 轮播海报
    interval: 3,
    // 轮播间隔（秒），仅 mode=2 生效
    imgWidth: 0,
    // 图片宽度（px，0 表示自适应）
    imgHeight: 0,
    // 图片高度（px，0 表示自适应）
    images: [
    // 图片列表（单图模式取第一项，轮播模式按顺序播放）
    {
      imgSrc: '',
      // 图片地址
      title: '',
      // 图片标题（用于 alt/无图占位）
      httpType: 10,
      // 跳转类型：10 内部链接 / 11 外部链接
      http: '' // 跳转地址
    }]
  }
});

/* ---------------------------- 1-3 图片导航 ---------------------------- */
componentProperties.set('graphicnavigation', {
  component: 'graphicnavigation',
  text: '图片导航',
  type: '1-3',
  active: false,
  style: 'graphicnavigationstyle',
  componentNumber: '',
  setStyle: {
    imageList: [],
    // 导航项列表：{ img, text, httpType, http }
    navigationType: 0,
    // 导航类型：0 混合 / 1 纯文字 / 2 纯图片
    imgStyle: 0,
    // 展示样式：0 固定个数 / 1 横向滑动
    showSize: 5,
    // 一屏显示的个数（imgStyle=0 时生效）
    textHeight: 30,
    // 文字行高（px）
    textSize: 14,
    // 文字字号（px）
    underline: false,
    // 是否显示文字下划线
    positions: 'center',
    // 文字对齐：left / center
    borderRadius: 0,
    // 圆角（px）
    backgroundColor: 'rgba(255,255,255,1)',
    // 整体背景色
    textColor: 'rgba(50,50,51,1)',
    // 文字颜色
    bgImg: '' // 背景图（为空则使用 backgroundColor）
  }
});

/* ------------------------------ 1-4 搜索 ------------------------------ */
componentProperties.set('search', {
  component: 'search',
  text: '搜索',
  type: '1-4',
  active: false,
  style: 'searchstyle',
  componentNumber: '',
  setStyle: {
    content: '搜索您需要的商品',
    // 占位提示文字
    positions: 'left',
    // 文字对齐：left / center
    position: 0,
    // 吸顶模式：0 正常 / 1 滚动至顶部固定
    sweep: false,
    // 是否显示扫一扫入口（预留）
    borderRadius: 0,
    // 搜索框圆角（px）
    height: 36,
    // 搜索框高度（px）
    showIcon: true,
    // 是否显示放大镜图标
    backgroundColor: 'rgba(255,255,255,1)',
    // 外层背景色
    borderColor: 'rgba(220,223,230,1)',
    // 搜索框填充色（用作框体背景）
    textColor: 'rgba(125,126,128,1)',
    // 占位文字颜色
    iconColor: 'rgba(125,126,128,1)',
    // 图标颜色
    textSize: 14,
    // 文字字号（px）
    hotords: [] // 热词列表（保留字段，预留扩展）
  }
});

/* ---------------------------- 1-5 辅助分割 ---------------------------- */
componentProperties.set('borderLine', {
  component: 'borderLine',
  text: '辅助分割',
  type: '1-5',
  active: false,
  style: 'borderLineStyle',
  componentNumber: '',
  setStyle: {
    borderColor: 'rgba(235,237,240,1)',
    // 分割线颜色
    borderType: 1,
    // 类型：0 空白占位 / 1 分割线
    borderLineType: 'solid',
    // 线型：solid 实线 / dashed 虚线 / dotted 点线
    margin: 12,
    // 左右边距（px）
    blankHeight: 20 // 空白占位高度（px，仅 borderType=0 生效）
  }
});

/* ------------------------------ 1-6 公告 ------------------------------ */
componentProperties.set('notice', {
  component: 'notice',
  text: '公告',
  type: '1-6',
  active: false,
  style: 'noticestyle',
  componentNumber: '',
  setStyle: {
    content: '这里是公告内容',
    // 公告文字
    borderRadius: 0,
    // 圆角（px）
    height: 36,
    // 公告栏高度（px）
    showIcon: true,
    // 是否显示喇叭图标
    backgroundColor: 'rgba(255,247,230,1)',
    // 背景色
    textColor: 'rgba(255,153,0,1)',
    // 文字颜色
    textSize: 14,
    // 文字字号（px）
    hotords: [],
    // 热词列表（保留字段，预留扩展）
    more: {
      // "查看更多" 配置
      show: false,
      // 是否显示
      type: 0,
      // 样式：0 文字+箭头 / 1 仅文字 / 2 仅箭头
      text: '查看更多',
      // 显示文字
      httpType: 10,
      // 跳转类型：10 内部链接 / 11 外部链接
      http: '' // 跳转地址
    }
  }
});

/* ---------------------------- 1-7 电梯导航 ---------------------------- */
componentProperties.set('elevatorNavigation', {
  component: 'elevatorNavigation',
  text: '电梯导航',
  type: '1-7',
  active: false,
  style: 'elevatorNavigationStyle',
  componentNumber: '',
  setStyle: {
    imageList: [],
    // 导航项列表：{ img, text, target(锚点id), httpType, http }
    navigationType: 0,
    // 导航类型：0 混合 / 1 纯文字 / 2 纯图片
    imgStyle: 0,
    // 展示样式：0 固定个数 / 1 横向滑动
    showSize: 5,
    // 一屏显示的个数（imgStyle=0 时生效）
    textHeight: 30,
    // 文字行高（px）
    textSize: 14,
    // 文字字号（px）
    underline: false,
    // 是否显示文字下划线
    positions: 'center',
    // 文字对齐：left / center
    borderRadius: 0,
    // 圆角（px）
    backgroundColor: 'rgba(255,255,255,1)',
    // 整体背景色
    textColor: 'rgba(50,50,51,1)',
    // 文字颜色
    bgImg: '' // 背景图（为空则使用 backgroundColor）
  }
});

/* ---------------------------- 1-8 热区切图 ---------------------------- */
componentProperties.set('hotspotCutout', {
  component: 'hotspotCutout',
  text: '热区切图',
  type: '1-8',
  active: false,
  style: 'hotspotCoutoutStyle',
  componentNumber: '',
  setStyle: {
    imageList: [
    // 切图列表（通常单张）
    {
      url: '',
      // 图片地址
      name: '',
      // 图片名称（用于管理识别）
      altText: '',
      // 替换文本（alt）
      hots: [] // 热区数组：{ id, title, link, x, y, width, height } 百分比 x y 宽 高
    }],
    imgStyle: 0,
    // 展示样式：0 常规 / 1 投影
    borderRadius: 0,
    // 圆角（px）
    pagePadding: 0,
    // 页面左右边距（px）
    imgWidth: 0,
    // 图片宽度（px，0 表示自适应）
    imgHeight: 0 // 图片高度（px，0 表示自适应）
  }
});

/* ------------------------------ 1-9 视频 ------------------------------ */
componentProperties.set('videoComponent', {
  component: 'videoComponent',
  text: '视频',
  type: '1-9',
  active: false,
  style: 'videoStyle',
  componentNumber: '',
  setStyle: {
    videoSrc: '',
    // 视频地址（uploadImg 上传后返回的 pathKey）
    bgSrc: '',
    // 背景图地址（为空则不显示背景）
    autoplay: true,
    // 是否自动播放（开启时强制静音，受浏览器限制）
    controls: true,
    // 是否显示播放控制条
    marginTop: 0,
    // 上边距（%，相对容器宽度）
    marginLeft: 0,
    // 左边距（%，相对容器宽度）
    videoWidth: 0,
    // 视频宽度（有背景图时：%，相对视频原始宽度；无背景图时：px；0 表示自适应）
    videoHeight: 0 // 视频高度（同 videoWidth 规则）
  }
});

/* --------------------------- 1-10 悬浮按钮 --------------------------- */
componentProperties.set('floatingButton', {
  component: 'floatingButton',
  text: '悬浮按钮',
  type: '1-10',
  active: false,
  style: 'floatingButtonStyle',
  componentNumber: '',
  setStyle: {
    btnText: '点击查看',
    // 按钮描述文字
    buttonWidth: 94,
    // 按钮宽度（px）
    buttonHeight: 37,
    // 按钮高度（px）
    isRound: true,
    // 是否圆角（true 大圆角胶囊 / false 直角）
    bottomOffset: 10,
    // 距底部偏移（% 屏幕宽度，相对手机可视区域底部）
    sideOffset: 4,
    // 距侧边偏移（% 屏幕宽度，position 为 left/right 时生效）
    position: 'center',
    // 水平位置：left 左侧 / center 居中 / right 右侧
    backgroundColor: 'rgba(24,144,255,1)',
    // 按钮背景色
    backgroundImg: '',
    // 按钮背景图（为空时使用背景色）
    bgWidth: 0,
    // 背景宽度（px，0 为自适应）
    bgHeight: 0,
    // 背景高度（px，0 为自适应）
    bgColor: '',
    // 背景颜色（为空时不填色）
    textColor: 'rgba(255,255,255,1)',
    // 文字颜色
    opacity: 100,
    // 不透明度（%，100 为完全不透明）
    httpType: 11,
    // 跳转类型：固定 11 外部链接
    http: '' // 跳转地址（小程序页面路径，如 /pages/index/index）
  }
});
var _default = exports.default = componentProperties;